import React , { useState ,  useEffect } from 'react';
import PropTypes from 'prop-types';
import './Contactus.scss';
import { contactFormValidation } from '../Re-usable/Validation';
import { Formik , Form , Field } from 'formik';
import '../OurServices/OurServices.scss'
import emailjs from 'emailjs-com';

import ErrorSvg from '../../images/error-svg.svg';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const Contactus = () => {
  
  const navigate = useNavigate()

  const canonicalUrl = "https://whitetowerinternational.com/ContactUs";

  const [message ,  setMessage] = useState();

  const numberingSocial = [
    {
      icon: 'bi bi-telephone',
      link: 'tel:+96895967179',
      text: '+96895967179'
    },
    {
      icon: 'bi bi-envelope',
      link: 'mailto:whitetowerinternational@gmail.com',
      text: 'whitetowerinternational@gmail.com'
    },
    {
      icon: 'bi bi-geo-alt',
      link: '',
      text: 'Sohar , Oman '
    },
  ]


  const socialLinks = [
    {
      icon: 'bi bi-instagram',
      link: 'https://www.instagram.com/whitetower3?igsh=d25mYTl4cHhtaXlm',
      toolTip: 'Instagram'
    },
    // {
    //   icon: 'bi bi-twitter-x',
    //   link: 'https://www.google.com',
    //   toolTip: 'Twitter'
    // },
    {
      icon: 'bi bi-whatsapp',
      link: 'https://wa.me/+96895967179',
      toolTip: 'WhatsApp'
    },
  ]


  const contactFromValues = {
    name: '',
    phone: '',
    email: ''
  }


  const conactPageFromSubmit = (values) => {
     // EmailJS configuration
     const serviceID = 'service_h7c337b';
     const templateID = 'template_sidynbr';
     const userID = 'MYhJGkvgTgncsGRU4';
 
     const templateParams = {
       from_name: values.name,
       email: values.email,
       number: values.phone,
       message: message,
     };
 
     emailjs.send(serviceID, templateID, templateParams , userID)
       .then((response) => {
          console.log(response , "response")
          console.log('SUCCESS!', response.status, response.text);
          navigate('/Thankyou')
       })
       .catch((error) => {
         console.log('FAILED...', error);
         alert('Failed to send message.');
       });
  }

  return (
    <div className="Contactus">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - Contact Us</title>
      </Helmet>
      <div className="main-contact-us-section">
        <div className="inner-contact-us-main-sec">
          <section className="contact-us-banner-section">
            <div className="inner-contact-us-banner-section">
              <div className="container">
                <div className="contact-us-banner-heading">
                  <h1>CONTACT US</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="contact-section-1">
            <div className="inner-contact-section-1">
              <div className="container">
                <div className="contact-section-1-from-main grid grid-cols-12 bg-white">
                  <div className="left-contact-social-block col-span-4 wow animate__animated animate__fadeInLeft">
                      <div className="top-numbering-contact-block">
                          <div className="reachus-heading mb-10">
                            <h4>Reach Us</h4>
                            <p>We value your inquiries! Reach out to White Tower International LLC for expert guidance on all your cargo handling requirements.</p>
                          </div>
                          <div className="bottom-number-contact-block flex flex-col gap-12">
                            {numberingSocial.map((items , index) => {
                              return (
                                <div className="single-number-contact-blk flex items-center gap-5" key={index}>
                                  <div className="left-icon-blk-contact">
                                    <i className={items.icon}></i>
                                  </div>
                                  <div className="right-icon-name-contact">
                                    <a className='' href={items.link}>{items.text}</a>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                      </div>
                      <div className="bottom-social-icons-contact flex overflow-hidden items-center gap-10">
                        {socialLinks.map((items , index) => {
                          return (
                            <button onClick={() => window.open(items.link, "_blank")} className="single-social-icon-contact relative group" key={index}>
                              <i className={items.icon}></i>
                              <div className="absolute tooltipper bg-black bg-opacity-45 
                                px-4 py-2 -top-20 left-0 opacity-0 
                                group-hover:-top-10 group-hover:opacity-100 duration-500 ">
                                  <p className='text-white text-sm'>{items.toolTip}</p>
                              </div>
                            </button>
                          )
                        })}
                      </div>
                  </div>
                  <div className="right-contact-form-section-main col-span-8 relative wow animate__animated animate__fadeInRight">
                      <div className="contact-form-top-section">
                          <div className="contact-page-form-heading mb-8">
                            <div className="ctheading-left-side">
                              <h4>Get In Touch With Us</h4>
                            </div>
                            
                          </div>
                          <div className="services-contact-section-right">
                            <Formik
                              validationSchema={contactFormValidation}
                              initialValues={contactFromValues}
                              onSubmit={(values) => conactPageFromSubmit(values)}
                            >
                              {({  errors, touched }) => (
                                  <Form>
                                      <div className="services-form-inner-section">
                                        <div className={`${errors.name && errors.email && errors.phone ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'} duration-500   error-message absolute flex items-center gap-5 top-8 right-8 bg-red-100 bg-opacity-30 border border-red-600 px-5 py-2`}>
                                          <img src={ErrorSvg} className='w-5 h-5' alt="" />
                                          <p className='text-red-600 font-bold'>Please Fill out Required Feilds</p>
                                        </div>
                                        <div className={`inner-services-form-section grid grid-cols-2 gap-7 ${errors.name && errors.email && errors.phone ? 'error-active' : ''}`}>
                                            <div className="single-services-contact-input-sec">
                                                <div className="top-lable-section-services">
                                                  <p>NAME</p>
                                                </div>
                                                <div className="input-services-sec mt-2">
                                                  <Field type="text" name="name" placeholder='Enter Name' 
                                                    className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.name && touched.name ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-[#B5B5B5] border-opacity-100 placeholder:text-black'}`} 
                                                  />
                                                </div>
                                            </div>
                                            <div className="single-services-contact-input-sec">
                                                <div className="top-lable-section-services">
                                                  <p>PHONE</p>
                                                </div>
                                                <div className="input-services-sec mt-2">
                                                  <Field type="number" name="phone" placeholder='Enter Mobile Number'
                                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                                    className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.phone && touched.phone ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-[#B5B5B5] border-opacity-100 placeholder:text-black'}`} 
                                                  />
                                                </div>
                                            </div>
                                            <div className="single-services-contact-input-sec col-span-2">
                                                <div className="top-lable-section-services">
                                                  <p>EMAIL</p>
                                                </div>
                                                <div className="input-services-sec mt-2">
                                                  <Field type="email" name="email" placeholder='Enter Email' 
                                                    className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.email && touched.email ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-[#B5B5B5] border-opacity-100 placeholder:text-black'}`} 
                                                  />
                                                </div>
                                            </div>
                                            <div className="single-services-contact-input-sec col-span-2">
                                                <div className="top-lable-section-services">
                                                  <p>COMMENT</p>
                                                </div>
                                                <div className="input-services-sec mt-2">
                                                  <textarea placeholder='Enter Your Message' className='resize-none w-full px-5 py-4 h-40 border-[#B5B5B5] border border-opacity-100' onChange={(e) => setMessage(e.target.value)} name="" id=""></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-submit-section-services mt-8">
                                          <button type="submit">
                                            <p className=''>SUBMIT</p>
                                          </button>
                                        </div>
                                      </div>
                                  </Form>
                                )}
                            </Formik>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="contact-us-section-3 wow animate__animated animate__backInUp">
            <div className="inner-contact-section-3">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d232651.27314126174!2d56.712644499999996!3d24.340356149999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8b44d363b81221%3A0xde9a3eefa60fc03f!2sSohar%2C%20Oman!5e0!3m2!1sen!2sin!4v1728201578659!5m2!1sen!2sin" width="100%" height="600" style={{border:0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

Contactus.propTypes = {};

Contactus.defaultProps = {};

export default Contactus;
